import React, { Component } from 'react'
import { Button, Popup } from 'semantic-ui-react';

import InviteUserModal from '../../../account/dashboard/drive/Modal/InviteUserModal'
import "./Toolbar.css";


class ToolbarPlatformUsers extends Component {
    constructor(props) {
        super(props);
        this.state = {
            inviteUserModalFlag: false
        }
    }

    setInviteUserModal = (open) => {
        this.setState({ inviteUserModalFlag: open })
    }

    gotoInviteUser = (e) => {
        this.setInviteUserModal(true)
    }

    render() {
        return (
            <div className="toolBar header_buttons">
                <Button.Group size='mini'>
                    <Popup className="popupStyled" inverted trigger={<span><Button icon='plus' className="clr-blue" onClick={this.gotoInviteUser} /></span>}
                        content='Invite User'
                    />
                </Button.Group>
                <InviteUserModal
                    open={this.state.inviteUserModalFlag}
                    setInviteUserModal={this.setInviteUserModal}
                    selectedAccount={this.props.selectedAccount}
                    user={this.props.user}
                    addedAccountUser={this.props.addedAccountUser}
                    invitedIn="platform"
                />
            </div>
        )
    }
}

export default ToolbarPlatformUsers


